import EventListingPrimaryView from '../EventListingPrimaryView';
import EventListingViewMode from '../EventListingViewMode';
import EventsListProductionsView from './EventsListProductionsView';
import DataStore from '../api/DataStore';

class EventsListView extends EventListingPrimaryView {
  constructor(config, keywordFilter, viewToggle) {
    super(config, keywordFilter, viewToggle);

    this.store = new DataStore();
    this.store.on('date', this.fetchData.bind(this));

    this.resultsView = new EventsListProductionsView(this.store, this.config);
  }

  getCurrentView() {
    return this.resultsView;
  }
}

EventsListView.ViewMode = EventListingViewMode.LIST;

export default EventsListView;



// WEBPACK FOOTER //
// ./V7/events/listing/listView/EventsListView.js